import * as React from "react";
import ButtonLink from "../../ButtonLink";
import Close from "../../icons/Close";
const DrawerClose = /*#__PURE__*/React.forwardRef(({
  onClick,
  title
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "ms-400"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onClick,
    iconLeft: /*#__PURE__*/React.createElement(Close, null),
    ref: ref,
    type: "secondary",
    title: title
  }));
});
export default DrawerClose;